import { IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { IPageExtra } from '../../types';
import { isLeadFactory } from '../agent';

export function getCplPageExtra(offer: IOfferSchema, siteBlockId?: number | null): Partial<IPageExtra> | undefined {
  if (offer.dealType !== 'sale') {
    return undefined;
  }

  const isFromDeveloper = Boolean(offer.newbuilding?.isFromDeveloper);

  return {
    cplDynamicCalltracking: siteBlockId ? 1 : 0,
    cplCalltracking: isFromDeveloper && !isLeadFactory(offer) ? 1 : 0,
  };
}
